import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Config from "../Config";
import Cookies from "js-cookie";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import { useAuthHandling } from '../useAuthhandling';
import AdminFormPage from "../AdminFormPage";
import FieldError from "../FieldError";
import { useAppFeedback } from "../useAppFeedback";

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setLocationType("ROOFTOP");

function Customeradd() {
  const { handleUnauthorized } = useAuthHandling();
  const { showError, showSuccess } = useAppFeedback();
  const [mobile, setMobile] = useState("");
  const [prof, setProf] = useState({
    name: "",
    email: "",

    password: "",
    cpassword: "",
  });
  const [location, setLocation] = useState({
    name: "Kochi, Kerala, India",
    lat: 9.9312,
    long: 76.2673,
  });

  const [loc, setLoc] = useState("Kochi, Kerala, India");
  const [loginValuenewph,setLoginValuenewph]=useState('');
  const [countrycodeval,setCountrycodeval]=useState('');
  const [countrycode,setCountryCode]=useState('');

  const [addressstring, setaddressstring] = useState(
    "W7M9+9C Kochi, Kerala, India"
  );

  const [formerror, setError] = useState({});
  const [formerror1, setError1] = useState({});

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setProf({ ...prof, [name]: value });
  };

  const validate = (values) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    const errors = {};
    if (!values.name) {
      errors.name = "Name is required!";
    }

    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }

    // if (!values.password) {
    //   errors.password = "password is required!";
    // }
    // else{
    //   if (!values.password.match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/)) {
    //     errors.password = "The password must contain minimum 8 characters and one number, one lowercase letter, one upper case letter and a special character.";
    //   }
    // }
    // if (!values.cpassword) {
    //   errors.cpassword = "confirm password is required!";
    // }
    // if(values.password && values.cpassword){
    //   if(values.password!==values.cpassword){
    //     errors.cpassword = "password and confirm password must be same!";

    //   }
    // }

    return errors;
  };

  const validate1 = (values) => {
    const errors = {};
    if (values < 4) {
      errors.mobile = "Contact number required!";
    }
    return errors;
  };
  const PostData = async (e) => {
    e.preventDefault();
    const ress = validate(prof);
    const ress1 = validate1(mobile);
    setError(ress);
    setError1(ress1);
    if (
      !ress.email &&
      !ress.name &&
      !ress1.mobile &&
      !ress.password &&
      !ress.cpassword
    ) {
      // axios.post(`${Config.apiurl}/api/v1/crm/professional/create-professional`, formData, { headers: {
      //     Authorization: `Bearer ${Cookies.get('token')}`,
      // },})
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/customer/create-customer`,
        {
          method: "POST",

          body: JSON.stringify({
            name: prof.name,
            email: prof.email,
            mobile: loginValuenewph,
            countryCode:countrycodeval,
            password: '#testPass1',
            confirmPassword: '#testPass1',
            // password: prof.password,
            inviteId: "",
            // confirmPassword: prof.cpassword,
            location: loc,
            latitude: location.lat,
            longitude: location.long,
            google_address_string: addressstring,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );

      if (res.status === 200 ) {
        await res.json();
        showSuccess("Sucessfully Created Account", {
          redirectTo: "/customerdetails",
        });
      } else if(res.status === 401){
        handleUnauthorized();
      } else {
        const data = await res.json();
        showError(data.message);
      }
    }
  };

  const handleChange = async (value) => {
    setLocation({
      name: value,
      lat: location.lat,
      long: location.long,
    });
    setLoc(value);
  };

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    Geocode.fromLatLng(latLng.lat, latLng.lng).then((response) => {
      const address = response.results[0].formatted_address;
      setaddressstring(address);
    });
    setLocation({
      name: value,
      lat: latLng.lat,
      long: latLng.lng,
    });
    setLoc(value);
  };

  useEffect(() => {
    // function getloc() {
    //   navigator.geolocation.getCurrentPosition(function (position) {
    //     console.log("datas", position);
    //     Geocode.fromLatLng(
    //       position.coords.latitude,
    //       position.coords.longitude
    //     ).then(
    //       (response) => {
    //         const address = response.results[0].formatted_address;
    //         const latlong = response.results[0].geometry.location;
    //         setaddressstring(address);
    //         console.log("adddss", address);
    //         const regex = /\d/;
    //         const locationstring = address.split(",");
    //         if (regex.test(locationstring[0])) {
    //           const part = locationstring[0].split(" ");
    //           if (part.length > 1) {
    //             setLocation({
    //               name: part[1] + "," + locationstring[1],
    //               lat: latlong.lat,
    //               long: latlong.lng,
    //             });
    //             setLoc(part[1] + "," + locationstring[1]);
    //           } else {
    //             setLocation({
    //               name: locationstring[1] + "," + locationstring[2],
    //               lat: latlong.lat,
    //               long: latlong.lng,
    //             });
    //             setLoc(locationstring[1] + "," + locationstring[2]);
    //           }
    //         } else {
    //           setLocation({
    //             name: locationstring[0] + "," + locationstring[1],
    //             lat: latlong.lat,
    //             long: latlong.lng,
    //           });
    //           setLoc(locationstring[0] + "," + locationstring[1]);
    //         }
    //       },
    //       (error) => {
    //         console.error(error);
    //       }
    //     );
    //   });
    // }
    // getloc();
  }, []);

  // const handleInputsphone = (value) => {
  //   setMobile(value);
  // };
  const handleInputsphone = (phone,country) => {
    let value =phone;
    setMobile(phone);
    setCountryCode(country.countryCode)
    setCountrycodeval(country.dialCode);
    const phoneWithoutCode = value.replace(`+${country.dialCode}`, "").trim();
    setLoginValuenewph(phoneWithoutCode);

  }
  return (
    <AdminFormPage title="User Add">
      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Name"
                            name="name"
                            value={prof.name}
                            onChange={handleInputs}
                            required
                          />
                          <FieldError message={formerror.name} />
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Email"
                            name="email"
                            value={prof.email}
                            onChange={handleInputs}
                            required
                          />
                          <FieldError message={formerror.email} />
                        </div>
                        <div className="form-group number">
                          {/* <label htmlFor="exampleInputUsername1">Mobile</label> */}
                          {/* <PhoneInput
                            country={"in"}
                            enableSearch={true}
                            value={prof.mobile}
                            onChange={(phone) => handleInputsphone(phone)}
                          /> */}
                          <PhoneInput
                            id="number"
                            name="mobile"
                            country={"in"}
                            enableSearch={true}
                            value={mobile}
                            onChange={ handleInputsphone}
                            // onChange={(phone) => handleInputsphone(phone)}
                          />
                          <FieldError message={formerror1.mobile} />
                        </div>
                        {/* <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Password"
                            name="password"
                            value={prof.password}
                            onChange={handleInputs}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerror.password}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Confirm Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Confirm password"
                            name="cpassword"
                            value={prof.cpassword}
                            onChange={handleInputs}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerror.cpassword}
                          </label>
                        </div> */}

                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Location
                          </label>
                          <PlacesAutocomplete
                            value={location.name}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            name="location"
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div className="position-relative">
                                <input
                                  className="form-control"
                                  {...getInputProps({
                                    placeholder: " Enter your location",
                                  })}
                                  required
                                />

                                <div className="autocomplete-dropdown-container">
                                  {loading ? <div>...Loading</div> : null}

                                  {suggestions.map((suggestion, key) => {
                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        };

                                    return (
                                      <div
                                        className="form-conterol"
                                        {...getSuggestionItemProps(suggestion, {
                                          style,
                                        })}
                                        key={key}
                                      >
                                        {suggestion.description}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                          {/* <input
                          className="form-control"
                          id="location"
                          type="text"
                          name="location"
                          placeholder="Location"
                          autoComplete="off"
                          required
                          value={loc}
                        /> */}
                        </div>

                        <button
                          type="submit"
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                      </form>
    </AdminFormPage>
  );
}
export default Customeradd;
